export default __webpack_public_path__ + "static/media/home-activities-afterparty-mobile.a930ae0c.png";